import { PropsWithChildren, ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useGlobalStore } from "../../../../store";
import { QueryClientProvider } from "@tanstack/react-query";
import { sharedQueryClient } from "@/app";

interface Props {
  children: ReactElement;
  to?: string;
}

const WrapperProvider = ({ children }: PropsWithChildren<any>) => {
  return (
    <QueryClientProvider client={sharedQueryClient}>
      {children}
    </QueryClientProvider>
  );
};
export default function RedirectIfAuthenticated(props: Props) {
  const { state } = useGlobalStore();
  const redirectTo = props.to ? props.to : "/home";

  return state.isUserLoggedIn ? (
    <WrapperProvider>
      <Navigate to={redirectTo} state={{ isRedirected: true }} replace />
    </WrapperProvider>
  ) : (
    <WrapperProvider>{props.children}</WrapperProvider>
  );
}
